import React from 'react';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { Constants, Globals } from 'utils';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { ClientQuoteService } from 'services';

class BFC extends React.Component<any> {

	async componentDidMount() {
		const {
			result
		} = queryString.parse(this.props.location.search);

		if (
			result != '1' ||
			!this.props.user ||
			this.props.user?.level_id != Constants.LEVELS.CLIENT
		) {
			this.props.history.replace('/client/quotes');
			Globals.showError("Lo sentimos, no se ha podido procesar su pago");
		}
		else {
			this.props.history.replace('/client/quotes');
			Globals.showSuccess("Su pago ha sido procesado correctamente");	
		}
	}

	render() {
		return null;
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(BFC);